import { render, staticRenderFns } from "./VDateField.vue?vue&type=template&id=41f65756"
import script from "./VDateField.vue?vue&type=script&lang=js"
export * from "./VDateField.vue?vue&type=script&lang=js"
import style0 from "./VDateField.vue?vue&type=style&index=0&id=41f65756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports